import { DeleteResultComponent } from './delete-result/delete-result.component';
import { HomeComponent } from './home/home.component';
import { homeChildRoutes } from './home/home.routing';

export const verificationHomeChildRoutes = [
  {
    component: DeleteResultComponent,
    path: 'delete-result/:ofuscatedData',
  },
  {
    component: HomeComponent,
    path: '',
    children: homeChildRoutes,
  },
];
